import { createSlice } from '@reduxjs/toolkit';
import { APIStatus } from '@application/enums/api-status';
import { getFaqCategoriesByEventIdAsync, getFaqsByEventIdForRegistrationAsync, getFaqCategoryByIdAsync, createFaqCategoryAsync, updateFaqCategoryAsync, deleteFaqCategoryAsync } from './faqCategoryThunk';
const initialState = {
    status: APIStatus.IDLE,
    categories: [],
    registrationCategories: [],
    selectedCategory: null
};
export const faqCategorySlice = createSlice({
    name: 'faqCategory',
    initialState,
    reducers: {
        clearSelectedCategory: (state) => {
            state.selectedCategory = null;
        },
        clearRegistrationCategories: (state) => {
            state.registrationCategories = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getFaqCategoriesByEventIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFaqCategoriesByEventIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.categories = action.payload;
        })
            .addCase(getFaqCategoriesByEventIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFaqsByEventIdForRegistrationAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFaqsByEventIdForRegistrationAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.registrationCategories = action.payload;
        })
            .addCase(getFaqsByEventIdForRegistrationAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getFaqCategoryByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getFaqCategoryByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            state.selectedCategory = action.payload;
        })
            .addCase(getFaqCategoryByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(createFaqCategoryAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(createFaqCategoryAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                state.categories.push(action.payload.data);
            }
        })
            .addCase(createFaqCategoryAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateFaqCategoryAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateFaqCategoryAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                const index = state.categories.findIndex((c) => c.id === action.payload.data?.id);
                if (index !== -1) {
                    state.categories[index] = action.payload.data;
                }
                if (state.selectedCategory?.id === action.payload.data.id) {
                    state.selectedCategory = action.payload.data;
                }
            }
        })
            .addCase(updateFaqCategoryAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(deleteFaqCategoryAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(deleteFaqCategoryAsync.fulfilled, (state, action) => {
            state.status = APIStatus.SUCCESS;
            if (action.payload.data) {
                state.categories = state.categories.filter((c) => c.id !== action.payload.data?.id);
                if (state.selectedCategory?.id === action.payload.data?.id) {
                    state.selectedCategory = null;
                }
            }
        })
            .addCase(deleteFaqCategoryAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { clearSelectedCategory, clearRegistrationCategories } = faqCategorySlice.actions;
export default faqCategorySlice.reducer;
